/**
    * Convierte el mensaje de respuesta con estructura XML recibido en la solicitud para obtener los filtros para gráficos, a formato JSON con estrucutura conveniente para su procesamiento.
    * @param {Object} xmlData - Mensaje recibido en solicitud de filtros para gráficos.
    * @returns {Array.<JSON>} Filtros del gráfico.
*/
function xmlParserFiltersData(xmlData) {
    var filters = [];
    const filtersArray = xmlData.getElementsByTagName('filter');
    filtersArray.map((filter, index) => {
        var item = {};
        var filterData = [];
        var defines = []
        if (filter.getElementsByTagName('defines')[0].children.length !== 0){
            var definesData = filter.getElementsByTagName('defines')[0].children;
            for (var i = 0; i < definesData.length; i++){
                var definesItem = {};
                definesItem['name'] = definesData[i].name;
                definesItem['value'] = definesData[i].value;
                defines.push(definesItem);
            }
        }
        else{
            defines = null;
        }
        item['filterId'] = filter.getElementsByTagName('id')[0].value;
        item['filterName'] = filter.getElementsByTagName('name')[0].value;
        item['defines'] = defines;
        var parameters = filter.getElementsByTagName('parameter');
        item['required'] = filter.getElementsByTagName('required')[0] === undefined ? false : true;
        //item['required'] = true;
        for (var i = 0; i < parameters.length; i++) {
            var idObject = parameters[i].getElementsByTagName('id')[0];
            var name = parameters[i].getElementsByTagName('name')[0] !== undefined ? parameters[i].getElementsByTagName('name')[0].value: null;
            if (idObject === undefined) {
                filterData.push(name);
            }
            else {
                var filterDataItem = {};
                var id = idObject.value;
                filterDataItem['name'] = name;
                filterDataItem['id'] = id;
                filterData.push(filterDataItem);
            }
        }

        var filtersArray = filter.getElementsByTagName('subFilter');
        var subFilters = [];
        filtersArray.map((subFilter, index) => {
            var subItem = {};
            var subFilterData = [];
            var subDefines = []
            if (subFilter.getElementsByTagName('subDefines')[0].children.length !== 0){
                var definesData = subFilter.getElementsByTagName('subDefines')[0].children;
                for (var i = 0; i < definesData.length; i++){
                    var definesItem = {};
                    definesItem['name'] = definesData[i].name;
                    definesItem['value'] = definesData[i].value;
                    subDefines.push(definesItem);
                }
            }
            else{
                subDefines = null;
            }
            subItem['filterId'] = subFilter.getElementsByTagName('subID')[0].value;
            subItem['filterName'] = subFilter.getElementsByTagName('subName')[0].value;
            subItem['defines'] = subDefines;
            var subParameters = subFilter.getElementsByTagName('subParameter');
            subItem['required'] = subFilter.getElementsByTagName('subRequired')[0] === undefined ? false : true;

            for (var i = 0; i < subParameters.length; i++) {
                var idObject = subParameters[i].getElementsByTagName('subParamID')[0];
                var name = subParameters[i].getElementsByTagName('subParamName')[0] !== undefined ? subParameters[i].getElementsByTagName('subParamName')[0].value: null;
                if (idObject === undefined) {
                    subFilterData.push(name);
                }
                else {
                    var filterDataItem = {};
                    var id = idObject.value;
                    filterDataItem['name'] = name;
                    filterDataItem['id'] = id;
                    subFilterData.push(filterDataItem);
                }
            }
            subItem['filterData'] = subFilterData;
            subFilters.push(subItem);
        })

        if(filtersArray.length > 0){
            item['subFilters'] = subFilters;
        }

        item['filterData'] = filterData;
        filters.push(item);
    })
    return filters;
}

export default xmlParserFiltersData;